import Icon from 'ui/components/Icon'
import { notifySuccess, notifyError } from 'ui/components/Notify'
import { LinkPreviewStyled, LinkWrap, Link, CopyButton } from './styled'

const LinkPreview = ({ link }) => {
  const copyLink = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
      notifySuccess('Ссылка скопирована')
    } catch (error) {
      notifyError('Не удалось скопировать ссылку')
    }
  }

  return (
    <LinkPreviewStyled>
      <LinkWrap>
        <Link href={link} target="_blank">
          {link}
        </Link>
        <CopyButton onClick={() => copyLink(link)}>
          <Icon name="copy" size="20" />
        </CopyButton>
      </LinkWrap>
    </LinkPreviewStyled>
  )
}

export default LinkPreview
